import React from "react";

export const useMovableMapElement = (
  movableShapeData,
  getMovedShapeData,
  courseWiseData,
  holeWiseData
) => {
  const { useEffect } = require("react");

  useEffect(() => {
    const handleKeyPress = (e) => {
      const step = 0.00001; // Adjust this value based on the desired step size
      let newCoordinates;
      let polygonCoordinates = movableShapeData?.list[0];
      if (polygonCoordinates) {
        switch (e.key) {
          case "ArrowUp": //forward
            newCoordinates = polygonCoordinates.map(([lat, lon]) => [
              lat + step,
              lon,
            ]);
            getMovedShapeData({
              ...movableShapeData,
              list: [newCoordinates],
            });

            break;
          case "ArrowDown": // backward
            newCoordinates = polygonCoordinates.map(([lat, lon]) => [
              lat - step,
              lon,
            ]);
            // setMovableShapeData(newCoordinates);
            getMovedShapeData({
              ...movableShapeData,
              list: [newCoordinates],
            });

            break;
          case "ArrowLeft": //left
            newCoordinates = polygonCoordinates.map(([lat, lon]) => [
              lat,
              lon - step,
            ]);
            // setMovableShapeData(newCoordinates);
            getMovedShapeData({
              ...movableShapeData,
              list: [newCoordinates],
            });

            break;
          case "ArrowRight": //right
            newCoordinates = polygonCoordinates.map(([lat, lon]) => [
              lat,
              lon + step,
            ]);
            // setMovableShapeData(newCoordinates);
            getMovedShapeData({
              ...movableShapeData,
              list: [newCoordinates],
            });

            break;
          default:
            break;
        }
      }
    };

    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [movableShapeData, courseWiseData, holeWiseData]);

  return null;
};
